// extracted by mini-css-extract-plugin
export default {"base":"avatar-module--base--xlYwd","sizeStretch":"avatar-module--size-stretch--DBI4l","sizeMd":"avatar-module--size-md--Zqosg","image":"avatar-module--image---kZju"};